import EpisodeCardBody from './EpisodeCardBody';

export default EpisodeCardBody;
